import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientMutation } from "../../../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../../../core/logManager";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { NotificationManager } from "../../../../../../../components/Notifications";

const INIT_STATE = {
  open: false,
  loading: false,
  result: null,
  error: null,
  deleteKeyFob: null,
  deleteKeyFobList: [],
  updateManageKeyFobResult: null,
};

const route = "modules/manage/modals/deleteManageKeyFob/redux/slice";

export const manageDeleteManageKeyFob = createAsyncThunk(
  "manage/deleteManageKeyFob/deleteManageKeyFob",
  async (payload, { rejectWithValue }) => {
    const mutations = [];
    try {
      const { id, items } = payload;
      if (id) {
        const data = await clientMutation(
          `mutation ($id: Int!){
            deleteKeyFob: deleteKeyFob(id: $id)
          }`,
          {
            id,
          },
          endpoints.GRAPHQL_GENERAL_V2
        );
        if (data?.deleteKeyFob) return data.deleteKeyFob;
        else throw "Error while deleting manage KeyFob";
      }
      if (items?.length) {
        items.forEach((manage, index) =>
          mutations.push(`deleteKeyFob${index}: deleteKeyFob(
                id: ${manage.id}
            )`)
        );
        const mutation = `mutation { ${mutations.join(" ")} }`;
        const data = await clientMutation(
          mutation,
          {
            id,
          },
          endpoints.GRAPHQL_GENERAL_V2
        );
        if (data?.deleteKeyFob0) return data.deleteKeyFob0;
        else throw "Error while deleting manage KeyFobs";
      }
    } catch (exc) {
      NotificationManager.error(
        "Error",
        `Error Deleting Manage KeyFob`,
        3000,
        null,
        null,
        "error"
      );
      ExceptionManager(exc, route, "deleteKeyFob");
      rejectWithValue(exc);
    }
  }
);

const manageDeleteManageKeyFobRedux = createSlice({
  name: "manage/deleteManageKeyFob",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    openModalDeleteManageKeyFob(state, action) {
      state.open = true;
      state.deleteKeyFob = action?.payload?.deleteKeyFob;
      state.deleteKeyFobList = action?.payload?.deleteKeyFobList;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageDeleteManageKeyFob
    builder.addCase(manageDeleteManageKeyFob.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageDeleteManageKeyFob.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(manageDeleteManageKeyFob.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageDeleteManageKeyFobRedux;

// Extract and export each action creator by name
export const { reset, openModalDeleteManageKeyFob } = actions;

// Export the reducer, either as a default or named export
export default reducer;
